module.exports = __webpack_public_path__ + "static/media/card-orthopride.407e2fc8.png";